/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { DateTime } from 'luxon';

interface Schedule {
  minutes: number;
  hours: number;
}

interface FormatBackupDateTimeParams {
  schedule?: Schedule;
  utc?: boolean;
  dateTime?: DateTime; // optional — default is now
}

export const formatBackupDateTimeWithTimezone = ({
  schedule,
  utc = false,
  dateTime = DateTime.now(),
}: FormatBackupDateTimeParams): string => {
  const baseUtc = dateTime.setZone('UTC');

  let displayDateTime: DateTime;

  if (schedule) {
    const { hours, minutes } = schedule;

    const shouldAddDay = baseUtc.hour > hours || (baseUtc.hour === hours && baseUtc.minute >= minutes);

    const scheduledUtc = baseUtc
      .plus({ days: shouldAddDay ? 1 : 0 })
      .set({ hour: hours, minute: minutes, second: 0, millisecond: 0 });

    displayDateTime = utc ? scheduledUtc.setZone('UTC') : scheduledUtc.setZone(DateTime.local().zoneName);
  } else {
    displayDateTime = utc ? baseUtc.setZone('UTC') : baseUtc.setZone(DateTime.local().zoneName);
  }

  const offset = displayDateTime.offset / 60;
  const sign = offset >= 0 ? '+' : '';

  return displayDateTime.toFormat(`dd LLLL, yyyy 'at' HH:mm '(UTC${sign}${offset})'`);
};
